import { emperor } from '~/services';
import { GlobalKeysResponse, ToggleGlobalKeyRequest } from '~/types/globalKeys';

export const getAllGlobalKeys = async (): Promise<{ data: GlobalKeysResponse }> => {
  return await emperor.get('globalkeys');
};

export const toggleGlobalKey = async (uuid: string, flag: boolean) => {
  const payload: ToggleGlobalKeyRequest = { uuid, flag };
  return await emperor.patch(`globalkeys/${uuid}`, payload);
}; 